import { Box, Button, DialogActions, DialogContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SuccessCarrotImage from '../../assets/images/success_carrot.png';
import { SettingsDialogViewProps } from './SettingsDialog';

export default function SettingsSaved({ next }: SettingsDialogViewProps): React.JSX.Element {
  const { t } = useTranslation(['common', 'settings']);

  return (
    <>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 0 }}>
        <Box
          component="img"
          src={SuccessCarrotImage}
          sx={{ width: '100%', mb: 2 }}
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, px: 3, textAlign: 'center' }}>
          <Typography variant="headlineSmall">
            {t('settings:your_profile_has_been_updated')}
          </Typography>
          <Typography variant="bodyMedium">
            {t('settings:your_profile_has_been_updated_description')}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => next()} variant="outlined">
          {t('common:close')}
        </Button>
        <Button onClick={() => next({ skipped: true })} variant="contained">
          {t('settings:see_my_profile')}
        </Button>
      </DialogActions>
    </>

  );
}
